import {Expose, Type} from 'class-transformer';
import {EventParticipationRequestApiModel} from './event-participation-request.api-model';

export class EventAttendanceDeclarationApiModel {
  @Expose() public id: number;
  @Expose() public status: 'ACTIVE' | 'CANCELLED';
  @Expose() public event: string;
  @Expose() public participantType: 'PRIVATE' | 'BUSINESS';
  @Expose() public representedCompany?: string | null;
  @Expose()
  @Type(() => EventParticipationRequestApiModel)
  public participationRequests: EventParticipationRequestApiModel[];
}

